import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { NeptuneApi } from '../genericApi/neptune.api';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { AdminAccountFolderApiModel } from './models/adminAccountFolderApiModel';
import { FolderApi } from '../folders/models/folder.api.model';

@Injectable()
export class AdminAccountsFoldersApi {

    constructor(
        private neptuneApi: NeptuneApi
    ) {}

    /**
     * Gets a list of folders for the account number passed in the parameters
     */
    public getCurrentUserAppPrefs(accountId: number): Observable<FolderApi[]> {
        const slug: string = `/mentions/folders/accounts/${accountId}`;

        return this.neptuneApi.api<FolderApi[]>(
            slug,
            null,
            HttpVerbsEnum.GET
        );
    }

    /**
     * Creates a new folder for the account passed in the parameters
     */
    public createAdminAccountFolder(accountId: number, folderPrefs: AdminAccountFolderApiModel): Observable<number> {
        const slug: string = `/mentions/folders/accounts/${accountId}`;

        return this.neptuneApi.api<number>(
            slug,
            folderPrefs,
            HttpVerbsEnum.POST,
        );
    }
}
